import React from 'react';
import { Card, Col, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useFetchDeviceServiceByEan from '../../hooks/useFetchDeviceServiceByEan';

interface DeviceDetailsServicesProps {
  ean: string | undefined;
  hasServices: boolean;
}

const DeviceDetailsServices: React.FC<DeviceDetailsServicesProps> = ({ ean, hasServices }) => {
  const { t } = useTranslation();
  const { serviceResponse } = useFetchDeviceServiceByEan({ ean: ean || '' });

  if (!hasServices) {
    return <></>;
  }
  return (
    <>
      <Col md={hasServices ? 4 : 6}>
        {serviceResponse?.length && serviceResponse?.length > 0 && (
          <Card id="canvasDeviceServiceDetail" className="shadow mt-3 text-center">
            <Card.Header className="bg-primary text-white clickable p-2" aria-controls="collapse-services">
              <Card.Title className="fs-3 fw-semibold my-1">{t("devices.services.title")}</Card.Title>
            </Card.Header>
            <Card.Body className='p-2'>
              <Table responsive striped hover className="table-sm m-0">
                <thead>
                  <tr>
                    <th className='p-1 small'>{t("devices.services.title")}</th>
                    <th className='p-1 small'>Versions</th>
                  </tr>
                </thead>
                <tbody>
                  {serviceResponse?.map(service => (
                    <tr key={service.id}>
                      <td className='fw-semibold text-muted p-1 small'>{service.name} :</td>
                      <td className='fw-medium p-1 small'>{service.version}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        )}
      </Col>
    </>
  );
};

export default DeviceDetailsServices;
